import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  pickerThemeOverrides: {
    '& .MuiPickersDay-root': {
      color: theme.palette.font.secondary,
    },
    '& .MuiPickersDay-root.Mui-selected': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: theme.palette.primary.contrastText,
    },
    '& .MuiPickersDay-root.Mui-selected:hover': {
      backgroundColor: `${theme.palette.primary.dark} !important`,
    },
    '& .MuiPickersDay-today': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
    '& .MuiPickersArrowSwitcher-button, & .MuiPickersCalendarHeader-switchViewButton':
      {
        color: theme.palette.text.primary,
      },
    '& .MuiPickersCalendarHeader-label': {
      color: theme.palette.text.primary,
    },
    '& .MuiPickersYear-yearButton, & .MuiPickersMonth-monthButton': {
      color: theme.palette.text.primary,
    },
    '& .MuiPickersYear-yearButton.Mui-selected, & .MuiPickersMonth-monthButton.Mui-selected':
      {
        color: theme.palette.primary.contrastText,
        backgroundColor: `${theme.palette.primary.main} !important`,
      },
  },
  actionBar: {
    padding: theme.spacing(2),
    display: 'none',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& > div': {
      width: '100%',
    },

    [theme.breakpoints.down('md')]: {
      display: 'flex',
      paddingBottom:
        'max(env(safe-area-inset-bottom, 0px), env(keyboard-inset-height, 0px))',
    },
  },
  mobileLayout: {
    [theme.breakpoints.down('md')]: {
      paddingTop: 'env(safe-area-inset-top, 0px)',
      minHeight:
        'calc(var(--vv-height, 100dvh) - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))',
      boxSizing: 'border-box',
    },
  },
  mobileHeader: {
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(1),
    },
  },
  errorButton: {
    '& svg': {
      color: theme.palette.error.main,
    },
  },
}));
